import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { de } from "date-fns/locale";
import { CalendarBlank } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// value/onChange use ISO "yyyy-MM-dd" strings, like native date inputs
export function DatePicker({ value, onChange, disabled, placeholder = "Datum wählen", className, ...rest }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parseISO(value) : undefined;
  const date = parsed && isValid(parsed) ? parsed : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled}
          className={cn("w-full justify-start gap-2 font-normal", !date && "text-muted-foreground", className)} {...rest}>
          <CalendarBlank size={15} />
          {date ? format(date, "dd.MM.yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={de} weekStartsOn={1} selected={date} defaultMonth={date}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
